import { ConnectionStatus, StatusCode } from '@yandex-video-platform/goloom-sdk';
import { call, put, select } from 'typed-redux-saga';

import { ErrorPageType } from '../../../../../shared/components/error-page/types';
import { setErrorPageAction } from '../../../../../shared/features/config';
import { selectIsReconnectFlowV2Enabled } from '../../../../../shared/features/config/selectors';
import { goloomSdk } from '../../../../../shared/features/goloom-sdk';
import { createLogger } from '../../../../../shared/helpers/loggerFacade';
import { Stopwatch } from '../../../../../shared/helpers/stopwatch';
import { ConnectionStatusEvent } from '../../../types';
import { sessionFailedSaga } from '../../offline';

const IGNORE_FAILED_STATUS_CODE = new Set([
    StatusCode.KICKED_OUT,
    StatusCode.PERMISSION_DENIED,
    StatusCode.ROOM_HAS_BEEN_CLOSED,
]);

const logger = createLogger('goloom:connection');
const stopwatch = new Stopwatch();

export function* handleConnectionStatusChangeSaga({
    current: connectionStatus,
    prev: prevConnectionStatus,
}: ConnectionStatusEvent) {
    const isV2Enabled = yield* select(selectIsReconnectFlowV2Enabled);

    switch (connectionStatus) {
        case ConnectionStatus.FAILED:
            if (goloomSdk.session?.errorCode && IGNORE_FAILED_STATUS_CODE.has(goloomSdk.session?.errorCode)) {
                return;
            }

            if (isV2Enabled) {
                yield* call(sessionFailedSaga);
                break;
            }

            yield* put(
                setErrorPageAction({
                    type: ErrorPageType.DEFAULT,
                    reason: {
                        method: 'handleConnectionStatusChangeSaga',
                        message: 'Connection status changed to failed',
                        code: Number(goloomSdk.session?.errorCode),
                        networkConfig: goloomSdk.session?.networkConfiguration,
                    },
                })
            );

            break;
        case ConnectionStatus.RECONNECTING:
            logger.warn('failure: initiation reconnect', {
                method: 'handleConnectionStatusChangeSaga',
                additional: {
                    kind: 'initiation_reconnect',
                    isV2Flow: isV2Enabled,
                },
            });

            stopwatch.start();

            break;
        case ConnectionStatus.CONNECTED:
            if (prevConnectionStatus === ConnectionStatus.RECONNECTING) {
                const time = stopwatch.stop();
                logger.warn('failure: success reconnect', {
                    method: 'handleConnectionStatusChangeSaga',
                    additional: {
                        kind: 'success_reconnect',
                        duration: time ? time / 1000 : undefined,
                        isV2ReconnectFlow: isV2Enabled,
                    },
                });
            }
            break;
        default:
            break;
    }
}
